let installPromptEvent = null;
let toastEl = null;

const STORAGE_KEY = "pwa_install_dismissed_until";
const DISMISS_DAYS = 10;
const NombreApp = "KNOWFLOW";
function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

function isSafari() {
  // Safari iOS y macOS (bastante aproximado)
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

function isIOSStandaloneCapable() {
  // iOS Safari no dispara beforeinstallprompt, pero permite "Add to Home Screen"
  return isIOS() && isSafari();
}

function getDismissedUntil() {
  const v = localStorage.getItem(STORAGE_KEY);
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function dismissForDays(days = DISMISS_DAYS) {
  const until = Date.now() + days * 24 * 60 * 60 * 1000;
  localStorage.setItem(STORAGE_KEY, String(until));
}

function isDismissed() {
  return Date.now() < getDismissedUntil();
}

function removeToast() {
  if (!toastEl) return;
  toastEl.remove();
  toastEl = null;
}

function hideToast() {
  if (!toastEl) return;

  toastEl.classList.remove("pwa-toast-show");
  toastEl.classList.add("pwa-toast-hide");

  setTimeout(() => {
    if (toastEl) toastEl.style.display = "none";
  }, 220);
}

function isAuthRoute() {
  const hash = window.location.hash.replace("#", "").split("?")[0];
  return ["", "login", "forgot-password", "register", "activate"].includes(hash);
}

function showToast() {
  if (!toastEl) createToast();

  if (isStandalone()) return;
  if (isDismissed()) return;
  if (isAuthRoute()) return;

  const canShowIOSGuide = isIOSStandaloneCapable();
  const canShowInstallPrompt = !!installPromptEvent;

  if (!canShowIOSGuide && !canShowInstallPrompt) return;

  // Ajustamos contenido según plataforma
  setToastMode(canShowIOSGuide ? "ios" : "install");

  toastEl.style.display = "flex";

  // reset clases
  toastEl.classList.remove("pwa-toast-hide");

  // Forzar reflow para que la transición arranque desde el estado oculto
  toastEl.getBoundingClientRect();
  toastEl.classList.add("pwa-toast-show");
}

function setToastMode(mode) {
  // mode: "install" | "ios"
  const title = toastEl.querySelector("[data-title]");
  const subtitle = toastEl.querySelector("[data-subtitle]");
  const installBtn = toastEl.querySelector("[data-install-btn]");

  if (mode === "ios") {
    title.textContent = `Instalá ${NombreApp}`;
    subtitle.textContent = "En iPhone: Compartir → Añadir a pantalla de inicio";
    installBtn.style.display = "none"; // en iOS no hay prompt automático
  } else {
    title.textContent = `Instalá ${NombreApp}`;
    subtitle.textContent = "Acceso rápido desde tu pantalla de inicio.";
    installBtn.style.display = "inline-flex";
  }
}

function createToast() {
  if (toastEl) return toastEl;

  toastEl = document.createElement("div");
  toastEl.id = "pwa-install-toast";

  const content = document.createElement("div");
  content.className = "pwa-content";

  const title = document.createElement("div");
  title.className = "pwa-title";
  title.setAttribute("data-title", "1");

  const subtitle = document.createElement("div");
  subtitle.className = "pwa-subtitle";
  subtitle.setAttribute("data-subtitle", "1");

  content.appendChild(title);
  content.appendChild(subtitle);

  const actions = document.createElement("div");
  actions.className = "pwa-actions";

  const installBtn = document.createElement("button");
  installBtn.type = "button";
  installBtn.className = "pwa-install-btn";
  installBtn.setAttribute("data-install-btn", "1");
  installBtn.innerHTML = "📲 Instalar";

  const closeBtn = document.createElement("button");
  closeBtn.type = "button";
  closeBtn.className = "pwa-close-btn";
  closeBtn.setAttribute("aria-label", "Cerrar");
  closeBtn.textContent = "✕";

  installBtn.addEventListener("click", async() => {
    if (!installPromptEvent) return;

    installPromptEvent.prompt();
    const choice = await installPromptEvent.userChoice;

    if (choice.outcome === "accepted") {
      hideToast();
    } else {
      dismissForDays();
      hideToast();
    }

    installPromptEvent = null;
  });

  closeBtn.addEventListener("click", () => {
    dismissForDays();
    hideToast();
  });

  actions.appendChild(installBtn);
  actions.appendChild(closeBtn);

  toastEl.appendChild(content);
  toastEl.appendChild(actions);

  document.body.appendChild(toastEl);

  title.textContent = `Instalá ${NombreApp}`;
  subtitle.textContent = "Acceso rápido desde tu pantalla de inicio.";

  return toastEl;
}

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  installPromptEvent = event;
  showToast();
});

window.addEventListener("appinstalled", () => {
  installPromptEvent = null;
  removeToast();
});

window.addEventListener("hashchange", () => {
  if (isAuthRoute()) {
    hideToast();
  } else {
    showToast();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  if (isStandalone()) return;
  createToast();

  // iOS: mostramos guía aunque no exista beforeinstallprompt
  if (isIOSStandaloneCapable() && !isDismissed()) {
    showToast();
  }
});
